import type { MacroPuckEditorComponentProps } from './MacroPuckEditorComponent';

export const MacroPuckEditorComponent = {
    MountAsync: async (target: HTMLElement, props: MacroPuckEditorComponentProps) => {
        const { mountReactComponentAsync } = await import('../../../js/mountReactComponentAsync');
        const { MacroPuckEditorComponent } = await import('./MacroPuckEditorComponent');
        return await mountReactComponentAsync(target, MacroPuckEditorComponent, props);
    }
};
